import { create } from "zustand";

export const useSplashStore = create((set) => ({
  isLoading: true,
  showSplash: false,
  isStarting: false,
  startExperience: () => set({ isStarting: true }),
  hideSplash: () => set({ showSplash: false, isLoading: false }),
}));
